import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page403Component } from './page403/page403.component';

import { Page404Component } from './page404/page404.component';
import { PolicyComponent } from './policy/policy.component';

const routes: Routes = [
    {
        path: '404',
        component: Page404Component
    }, {
        path: '403',
        component: Page403Component
    }, {
        path: 'policy',
        component: PolicyComponent
    },
];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ExtrapagesRoutingModule { }
